import React from 'react';
import NodeWrapper from './NodeWrapper';
import DigitalTwin from './themes/classic/DigitalTwin';

const CustomInput = (props) => {

  const iconStyle = {
    top: '30%',
    left: '29%',
  }

  return (
    <NodeWrapper {...props}>     
        <DigitalTwin props={props} iconStyle={iconStyle} />
    </NodeWrapper>
  );
};

export default CustomInput;
// isValidConnection={validations('source', 'clusterlet')}
